/**
 * 📋 SDLC 6.5.0 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/utils/date.ts
 * PURPOSE: The one helper that turns a Date into its LOCAL calendar day
 *          (YYYY-MM-DD) for API date params and day keys (#1366).
 * SDLC FRAMEWORK VERSION: 6.5.0 (7-Pillar + 9 Mental Models + Long-Running Agent Protocol)
 * DATE: 2026-10-07
 * COMPLIANCE: SDLC 6.5.0 + Zero-Mock Tolerance
 * PILLAR: P1 (Stage 06 - BUILD)
 * SPRINT GOVERNANCE: Rule 3: Zero-Mock Tolerance
 *
 * @business-context
 * - Domain: every page that sends or compares a calendar day (attendance,
 *   schedule, leave, shift swap, tasks, approvals, analytics)
 * - Impact: `d.toISOString().split('T')[0]` is the UTC day. In a Vietnam
 *   browser (UTC+7) it is one day early for local-midnight dates and for
 *   "today" between 00:00 and 06:59.
 *
 * @technical-architecture
 * - Layer: Pure utility (no I/O, no React)
 *
 * @cross-references
 * - Moved from frontend/src/pages/TasksProfessional.tsx (mobile fix:
 *   mobile/src/screens/tasks/TaskListScreen.tsx:201-205); #1364 (A3), #1366
 * ===============================================================================
 */

/** Local calendar day of `d` as YYYY-MM-DD (not the UTC day of toISOString()). */
export function toLocalISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
